// extracted by mini-css-extract-plugin
export default {"container":"Gift_container__22o6B","giftCard":"Gift_giftCard__kkxfH","giftImage":"Gift_giftImage__6LhDm"};